module.exports = __webpack_public_path__ + "static/groomsbride-71934d674099915cda699dcfce9b2b5c.png";